// import debug from "debug";
// const log = debug("sales-force-push");

function injectScript(src) {
    return new Promise((resolve, reject)=>{
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.addEventListener('load', resolve);
        script.addEventListener('error', e => reject(e.error));
        document.head.appendChild(script);
    });
}

export default injectScript;



// WEBPACK FOOTER //
// ./project/client/src/core/modules/sales-force-push/inject-script.js